import React, { useRef, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { InputLabel, FormHelperText, Tooltip, IconButton, Button, Box, Grid, ButtonGroup } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import SignaturePad from 'react-signature-canvas';
import { TextBox as InputText, DateTimePicker } from '../../../Core/FormInput';
import DialogComp from '../../../Core/Modal/dialogModal';
import VisibilityIcon from '@material-ui/icons/Visibility';
import BorderColorIcon from '@material-ui/icons/BorderColor';
import { useWindowSize } from '../../../Core/Controls/ScreenResolution';

const useStyles = makeStyles((theme) => ({
    fieldContainer: {
        marginBottom: '0px',
        width: '100%',
        transition: 'all 0.3s ease',
        display: 'flex',
        alignItems: 'flex-start'
    },
    label: {
        fontSize: '13px',
        fontWeight: 600,
        color: '#495057',
        marginBottom: '4px',
        display: 'inline-block'
    },
    errorText: {
        color: '#f50057',
        fontSize: '12px',
        marginTop: '4px',
        fontWeight: 500
    },
    buttonGroup: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'nowrap',
        gap: '6px',
        width: '100%'
    }
}));

export const CheckFieldType = ({
    fieldTypeId,
    name,
    value,
    onChange,
    label,
    placeholder,
    options = [],
    error,
    disabled = false,
    required = false,
    btnList = [],
    CheckButtons = {},
    changeState,
    p,
    listType,
    listOptionsVM = [],
    photoUploadComponent
}) => {
    const classes = useStyles();
    const sigCanvas = useRef({});
    const [showSign, setShowSign] = useState(false);

    const [widths] = useWindowSize();

    const handleSignatureEnd = () => {
        if (sigCanvas.current && !sigCanvas.current.isEmpty()) {
            const dataUrl = sigCanvas.current.getTrimmedCanvas().toDataURL('image/png');
            onChange({ target: { name, value: dataUrl } });
        }
    };

    const handleClearSignature = () => {
        if (sigCanvas.current && sigCanvas.current.clear) {
            sigCanvas.current.clear();
        }
        onChange({ target: { name, value: '' } });
    };

    // Helper to simulate a native event object for custom component interactions
    const triggerChange = (val) => {
        onChange({ target: { name, value: val } });
    };

    const renderField = () => {
        switch (fieldTypeId) {
            case 'CO':
                return (
                    <div className={classes.buttonGroup}>
                        <Grid container spacing={1} alignItems="center" style={{ flexWrap: 'nowrap', gap: 4 }}>
                            {btnList.map((b) => {
                                const Comp = CheckButtons[b.inspectionSheetCheckOptionCode] || Button;
                                return (
                                    <Grid item key={b.inspectionSheetCheckOptionCode}>
                                        <Comp
                                            onClick={() => !disabled && changeState(b.inspectionSheetCheckOptionCode, p.inspectionSheetCheckID)}
                                            state={p.inspectionSheetCheckResultOptionCode === b.inspectionSheetCheckOptionCode}
                                            style={disabled ? { pointerEvents: 'none' } : {}}
                                        />
                                    </Grid>
                                );
                            })}
                        </Grid>
                    </div>
                );

            case 'DT': // Date Time
                return (
                    <DateTimePicker
                        placeholder={placeholder || label}
                        name={name}
                        value={value || ''}
                        onChange={onChange}
                        disabled={disabled}
                        InputProps={{
                            style: {
                                height: 38,
                                backgroundColor: '#fff',
                                fontSize: 12
                            }
                        }}
                        style={{ backgroundColor: '#fff', height: 38, margin: 0 }}
                    />
                );

            case 'LT': // List
                const selectedList = listOptionsVM.filter((k) => k.inspectionSheetListId === p.inspectionSheetCheckListTypeID) || [];
                return (
                    <Box display="flex" justifyContent="flex-start">
                        <ButtonGroup variant="outlined" color="primary" aria-label="inspection options" style={{ height: 38 }}>
                            {selectedList.map((k) => {
                                const isSelected = value === k.name;

                                return (
                                    <Button
                                        key={k.id || k.name}
                                        variant={isSelected ? 'contained' : 'outlined'}
                                        disabled={disabled}
                                        onClick={() => triggerChange(k.name)}
                                        style={{
                                            height: 38,
                                            minHeight: 38,
                                            padding: '0 14px',
                                            fontSize: 12,
                                            fontWeight: 600,
                                            textTransform: 'uppercase',
                                            // borderRadius: 6,
                                            ...(isSelected
                                                ? {
                                                      backgroundColor: k.backgroundColour || '#f50057',
                                                      color: k.foregroundColour || '#fff',
                                                      borderColor: k.backgroundColour || '#f50057'
                                                  }
                                                : {})
                                        }}
                                    >
                                        {k.name}
                                    </Button>
                                );
                            })}
                        </ButtonGroup>
                    </Box>
                );

            case 'ML': // Multiline Text
                return (
                    <InputText
                        margin="none"
                        multiline
                        rows={3}
                        rowsMax={3}
                        // placeholder={placeholder || label || 'Enter details...'}
                        name={name}
                        value={value || ''}
                        onChange={onChange}
                        disabled={disabled}
                        fullWidth
                        // InputProps={{
                        //     style: {
                        //         minHeight: 38,
                        //         height: 38,
                        //         backgroundColor: '#fff',
                        //         fontSize: 12
                        //     }
                        // }}
                        inputProps={{
                            style: {
                                padding: '2px',
                                // fontSize: 12,
                                boxSizing: 'border-box'
                            }
                        }}
                        // style={{ backgroundColor: '#fff', fontSize: 12, margin: 0, height: 38 }}
                    />
                );

            case 'SB': // Signature
                return (
                    <div style={{ position: 'relative' }}>
                        <Button
                            color="primary"
                            variant={value ? 'contained' : 'outlined'}
                            size="small"
                            onClick={() => setShowSign(true)}
                            startIcon={disabled ? <VisibilityIcon /> : <BorderColorIcon />}
                            style={{ textTransform: 'uppercase', fontSize: 12, padding: '0 14px', height: 38, minHeight: 38, borderRadius: 6 }}
                        >
                            Signature
                        </Button>
                        {showSign ? (
                            <DialogComp onClose={() => setShowSign(false)} title="Signature">
                                <div style={{ padding: 10 }}>
                                    {value ? (
                                        <Box
                                            style={{
                                                position: 'relative',
                                                border: '1px solid rgba(0, 0, 0, 0.23)',
                                                borderRadius: 6,
                                                padding: '12px',
                                                background: '#fcfcfc',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                minWidth: '350px',
                                                minHeight: 150,
                                                boxSizing: 'border-box'
                                            }}
                                        >
                                            <img
                                                src={value}
                                                alt="signature"
                                                style={{
                                                    maxWidth: '100%',
                                                    maxHeight: '120px',
                                                    objectFit: 'contain'
                                                }}
                                            />
                                            {!disabled && (
                                                <Tooltip title="Clear and Resign">
                                                    <IconButton
                                                        onClick={handleClearSignature}
                                                        style={{
                                                            position: 'absolute',
                                                            top: 6,
                                                            right: 6,
                                                            color: '#f50057',
                                                            backgroundColor: 'rgba(245, 0, 87, 0.05)'
                                                        }}
                                                        size="small"
                                                    >
                                                        <DeleteIcon fontSize="small" />
                                                    </IconButton>
                                                </Tooltip>
                                            )}
                                        </Box>
                                    ) : (
                                        <Box
                                            style={{
                                                border: '1px solid rgba(0, 0, 0, 0.23)',
                                                borderRadius: 6,
                                                background: '#fff',
                                                position: 'relative',
                                                minWidth: '350px',
                                                overflow: 'hidden'
                                            }}
                                        >
                                            <SignaturePad
                                                ref={sigCanvas}
                                                canvasProps={{
                                                    style: {
                                                        width: '100%',
                                                        height: 150,
                                                        display: 'block',
                                                        cursor: 'crosshair',
                                                        backgroundColor: '#fafafa'
                                                    },
                                                    className: 'sigPad'
                                                }}
                                                onEnd={handleSignatureEnd}
                                            />
                                            <Tooltip title="Clear">
                                                <IconButton
                                                    onClick={handleClearSignature}
                                                    style={{
                                                        position: 'absolute',
                                                        top: 6,
                                                        right: 6,
                                                        color: '#f50057',
                                                        backgroundColor: 'rgba(255, 255, 255, 0.8)'
                                                    }}
                                                    size="small"
                                                >
                                                    <DeleteIcon fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                        </Box>
                                    )}
                                </div>
                            </DialogComp>
                        ) : null}
                    </div>
                );

            case 'SL': // Single Line Text
                return (
                    <InputText
                        margin="none"
                        // placeholder={placeholder || label || 'Enter details...'}
                        name={name}
                        value={value || ''}
                        onChange={onChange}
                        disabled={disabled}
                        fullWidth
                        InputProps={{
                            style: {
                                height: 38,
                                backgroundColor: '#fff'
                                // fontSize: 12
                            }
                        }}
                        inputProps={{
                            style: {
                                padding: '2px 10px',
                                // fontSize: 12,
                                boxSizing: 'border-box'
                            }
                        }}
                        style={{ backgroundColor: '#fff', fontSize: 12, margin: 0, height: 38 }}
                    />
                );
            default:
                return null;
        }
    };

    const renderFieldWithPhoto = () => {
        const field = renderField();
        if (photoUploadComponent) {
            return (
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', width: '100%', gap: '8px' }}>
                    <div style={{ display: 'flex', alignItems: 'flex-start', flex: 1, minWidth: 0 }}>{field}</div>
                    <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-end', flexShrink: 0, marginLeft: 'auto' }}>
                        {photoUploadComponent}
                    </div>
                </div>
            );
        }
        return field;
    };

    return (
        <div className={classes.fieldContainer}>
            {label && (
                <InputLabel required={required} error={!!error} className={classes.label} shrink>
                    {label}
                </InputLabel>
            )}
            {renderFieldWithPhoto()}
            {error && (
                <FormHelperText error className={classes.errorText}>
                    {error}
                </FormHelperText>
            )}
        </div>
    );
};

export default CheckFieldType;
